var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      ref: "table",
      staticClass: "c-table",
      class: {
        "c-table_scrolled": _vm.isScrolled,
        "c-table_scroll_end": _vm.isScrollEnd,
        "c-table_scroll": _vm.isScroll,
      },
    },
    [
      _c("m-column-filters", {
        ref: "columnFilters",
        attrs: {
          column: _vm.filteredColumn,
          "reference-list": _vm.referenceList,
          "active-filters": _vm.activeFilteredColumns,
        },
        on: {
          getReferenceValues: _vm.getReferenceValues,
          close: function ($event) {
            _vm.filteredColumn = null
          },
          setFilter: _vm.setColumnFilter,
          removeFilter: _vm.removeColumnFilter,
        },
      }),
      _vm.data.records.length !== 0
        ? _c("div", {
            class: {
              "c-table__shadow": _vm.data.actions,
              "c-table__shadow_active": _vm.data.actions,
              // 'c-table__empty__shadow': data.records.length === 0
            },
          })
        : _vm._e(),
      _vm.isScroll
        ? _c("div", { staticClass: "c-table__scrollbar-wrapper" })
        : _vm._e(),
      _c("div", { staticClass: "c-table__wrapper" }, [
        _c("table", { ref: "container", staticClass: "c-table__container" }, [
          _c(
            "thead",
            { ref: "header", staticClass: "c-table__header" },
            _vm._l(_vm.levels, function (i) {
              return _c(
                "tr",
                { key: i, staticClass: "c-table__header-row" },
                [
                  _vm._l(_vm.getTableColumns(i), function (column) {
                    return _c(
                      "th",
                      {
                        key: column.id,
                        staticClass: "c-table__column",
                        class: {
                          "c-table__column_with_filter": column.type,
                          "c-table__column_hidden": _vm.isDisabled(column.id),
                          "c-table__column_sorted": _vm.isSorted(column),
                        },
                        style: { width: column.width ? column.width : "" },
                        attrs: {
                          id: `c-table-column-${column.id}`,
                          colspan: _vm.getColspan(column),
                          rowspan: _vm.getRowspan(column),
                        },
                      },
                      [
                        _c("div", { staticClass: "c-table__column-wrapper" }, [
                          _c(
                            "div",
                            {
                              staticClass: "c-table__column-label",
                              class: {
                                "c-table__column-label-children":
                                  !_vm.isCategory(column) && _vm.sortedColumn,
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.setSortedColumn(
                                    column,
                                    _vm.sortedColumn
                                  )
                                },
                              },
                            },
                            [_vm._v(" " + _vm._s(column.label) + " ")]
                          ),
                        ]),
                      ]
                    )
                  }),
                  _vm.data.actions && i === 1
                    ? _c(
                        "th",
                        {
                          staticClass:
                            "c-table__column c-table__column_actions",
                          attrs: { rowspan: _vm.levels },
                        },
                        [_c("div", { staticClass: "c-table__column-empty" })]
                      )
                    : _vm._e(),
                ],
                2
              )
            }),
            0
          ),
          _c(
            "tbody",
            { staticClass: "c-table__records" },
            [
              _vm._l(_vm.data.records, function (record, recordIndex) {
                return [
                  record.isShowRow
                    ? [
                        _c(
                          "tr",
                          {
                            key: `transaction-${recordIndex}`,
                            staticClass: "c-table__record",
                          },
                          [
                            _vm._l(
                              _vm.getTableColumns(_vm.levels),
                              function (column) {
                                return _c(
                                  "td",
                                  {
                                    key: column.id,
                                    staticClass: "c-table__cell",
                                    class: {
                                      "c-table__cell_string":
                                        column.type === "string",
                                      "c-table__cell_reference":
                                        column.type === "reference",
                                      "c-table__cell_number":
                                        column.type === "number",
                                      "c-table__cell_date":
                                        column.type === "date",
                                      "c-table__cell_hidden": _vm.isDisabled(
                                        column.id
                                      ),
                                      "c-table__cell__green":
                                        column.id === "sum_bonus" &&
                                        record[column.id].value > 0,
                                      "c-table__cell__red":
                                        column.id === "sum_penalty" &&
                                        record[column.id].value > 0,
                                      ["c-table__cell_" + column.id]: column.id,
                                    },
                                  },
                                  [
                                    column.id !== "date" &&
                                    column.id !== "amount"
                                      ? _c(
                                          "div",
                                          {
                                            staticClass: "c-table__cell-value",
                                            class: {
                                              "c-table__cell-pre-formatted":
                                                column.id ===
                                                "postCategorySpecialty",
                                            },
                                          },
                                          [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  _vm.numberWithSpaces(
                                                    record[column.id].value
                                                  )
                                                ) +
                                                " "
                                            ),
                                          ]
                                        )
                                      : column.id === "amount"
                                      ? _c(
                                          "div",
                                          {
                                            staticClass: "c-table__cell-value",
                                            class: {
                                              "c-table__cell__text__green":
                                                record[column.id].value > 0,
                                              "c-table__cell__text__red":
                                                record[column.id].value < 0,
                                            },
                                          },
                                          [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  _vm.formatAmount(
                                                    record[column.id].value
                                                  )
                                                ) +
                                                " "
                                            ),
                                          ]
                                        )
                                      : column.id === "date"
                                      ? _c(
                                          "div",
                                          {
                                            staticClass:
                                              "c-table__cell-value c-table__cell-value-dropdown",
                                          },
                                          [
                                            record.childrens.length > 0
                                              ? _c(
                                                  "svg",
                                                  {
                                                    directives: [
                                                      {
                                                        name: "b-toggle",
                                                        rawName: "v-b-toggle",
                                                        value:
                                                          recordIndex.toString(),
                                                        expression:
                                                          "recordIndex.toString()",
                                                      },
                                                    ],
                                                    staticClass:
                                                      "c-table__cell-value-dropdown-button",
                                                    attrs: {
                                                      width: "22",
                                                      height: "22",
                                                      viewBox: "0 0 22 22",
                                                      fill: "none",
                                                      xmlns:
                                                        "http://www.w3.org/2000/svg",
                                                    },
                                                  },
                                                  [
                                                    _c("circle", {
                                                      attrs: {
                                                        cx: "11",
                                                        cy: "11",
                                                        r: "10.5",
                                                        fill: "white",
                                                        stroke: "#D3D8DF",
                                                      },
                                                    }),
                                                    _c("path", {
                                                      attrs: {
                                                        d: "M10.5398 13.4727C10.2813 13.2141 10.2813 12.7948 10.5398 12.5361L13.87 9.20431C14.1285 8.94569 14.5476 8.94569 14.8061 9.20432C15.0646 9.46294 15.0646 9.88225 14.8061 10.1409L11.4759 13.4727C11.2174 13.7313 10.7983 13.7313 10.5398 13.4727Z",
                                                        fill: "#0066FF",
                                                      },
                                                    }),
                                                    _c("path", {
                                                      attrs: {
                                                        d: "M11.4706 13.4727C11.7291 13.2141 11.7291 12.7948 11.4706 12.5361L8.12999 9.19397C7.87149 8.93534 7.45238 8.93534 7.19388 9.19397C6.93537 9.45259 6.93537 9.8719 7.19388 10.1305L10.5345 13.4727C10.793 13.7313 11.2121 13.7313 11.4706 13.4727Z",
                                                        fill: "#0066FF",
                                                      },
                                                    }),
                                                  ]
                                                )
                                              : _vm._e(),
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "c-table__cell-value-dropdown-value",
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    record[column.id].value
                                                  )
                                                ),
                                              ]
                                            ),
                                          ]
                                        )
                                      : _vm._e(),
                                  ]
                                )
                              }
                            ),
                            _vm.data.actions
                              ? _c(
                                  "td",
                                  {
                                    staticClass:
                                      "c-table__cell c-table__cell_actions",
                                  },
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "c-table__cell-actions" },
                                      [
                                        _c("c-table-actions", {
                                          attrs: { record: record },
                                        }),
                                      ],
                                      1
                                    ),
                                  ]
                                )
                              : _vm._e(),
                          ],
                          2
                        ),
                        _vm._l(record.childrens, function (rec) {
                          return [
                            record.childrens.length > 0
                              ? _c(
                                  "tr",
                                  {
                                    key: `record-${rec.workerName}`,
                                    staticClass:
                                      "c-table__record c-table__record__grey",
                                    staticStyle: {
                                      "border-bottom-style": "hidden",
                                      "border-top-style": "hidden",
                                    },
                                  },
                                  [
                                    _vm._l(
                                      _vm.getTableColumns(_vm.levels),
                                      function (column) {
                                        return _c(
                                          "td",
                                          {
                                            key: column.id,
                                            staticClass: "c-table__cell",
                                            class: {
                                              "c-table__cell_string":
                                                column.type === "string",
                                              "c-table__cell_reference":
                                                column.type === "reference",
                                              "c-table__cell_number":
                                                column.type === "number",
                                              "c-table__cell_date":
                                                column.type === "date",
                                              "c-table__cell_hidden":
                                                _vm.isDisabled(column.id),
                                              "c-table__cell__green":
                                                column.id === "sum_bonus" &&
                                                rec[column.id].value > 0,
                                              "c-table__cell__red":
                                                column.id === "sum_penalty" &&
                                                rec[column.id].value > 0,
                                              ["c-table__cell_" + column.id]:
                                                column.id,
                                            },
                                          },
                                          [
                                            _c(
                                              "b-collapse",
                                              {
                                                attrs: {
                                                  id: recordIndex.toString(),
                                                },
                                              },
                                              [
                                                column.id === "date"
                                                  ? _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "c-table__cell-value c-table__cell__grey",
                                                      },
                                                      [
                                                        _vm._v(
                                                          " " +
                                                            _vm._s(
                                                              rec.workerName
                                                            ) +
                                                            " "
                                                        ),
                                                      ]
                                                    )
                                                  : column.id === "amount"
                                                  ? _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "c-table__cell-value",
                                                        class: {
                                                          "c-table__cell__text__green":
                                                            rec[column.id]
                                                              .value > 0,
                                                          "c-table__cell__text__red":
                                                            rec[column.id]
                                                              .value < 0,
                                                        },
                                                      },
                                                      [
                                                        _vm._v(
                                                          " " +
                                                            _vm._s(
                                                              _vm.formatAmount(
                                                                rec[column.id]
                                                                  .value
                                                              )
                                                            ) +
                                                            " "
                                                        ),
                                                      ]
                                                    )
                                                  : _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "c-table__cell-value",
                                                      },
                                                      [
                                                        _vm._v(
                                                          " " +
                                                            _vm._s(
                                                              rec[column.id]
                                                                .value
                                                            ) +
                                                            " "
                                                        ),
                                                      ]
                                                    ),
                                              ]
                                            ),
                                          ],
                                          1
                                        )
                                      }
                                    ),
                                    _vm.data.actions
                                      ? _c(
                                          "td",
                                          {
                                            staticClass:
                                              "c-table__cell c-table__cell_actions",
                                            staticStyle: { width: "40px" },
                                          },
                                          [
                                            _c(
                                              "b-collapse",
                                              {
                                                attrs: {
                                                  id: recordIndex.toString(),
                                                },
                                              },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "c-table__cell__grey c-table__cell-actions",
                                                  },
                                                  [
                                                    _c("c-table-actions", {
                                                      attrs: { record: rec },
                                                    }),
                                                  ],
                                                  1
                                                ),
                                              ]
                                            ),
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                  ],
                                  2
                                )
                              : _vm._e(),
                          ]
                        }),
                      ]
                    : _vm._e(),
                ]
              }),
            ],
            2
          ),
        ]),
      ]),
      _vm.data.records.length === 0
        ? _c("div", { staticClass: "c-table__empty__records" }, [
            _vm._v(_vm._s(_vm.emptyRecordsLabel)),
          ])
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }